<template>
  <div class="occurrence-editor">
    <quillEditor
      class="mb-2 my-"
      :options="occurrenceOptions"
      v-model="form.description"
      data-testId="occurrence-textarea"
    />

    <div class="flex flex-row gap-4 items-center">
      <span class="text-base font-bold">Anexos:</span>

      <div>
        <vs-input
          id="Upload de arquivos"
          name="Upload de arquivos"
          type="file"
          multiple
          hidden
          style="display: none"
          @change="handleFiles($event.target.files)"
        />
        <vs-button
          @click.prevent="chooseFiles('Upload de arquivos')"
          data-testId="upload-file-button"
          icon-pack="feather"
          icon="icon-upload"
        >
        </vs-button>
      </div>
    </div>

    <div
      v-for="(item, index) in form.attachments"
      :key="index"
      class="flex flex-row items-center pt-2"
    >
      <span> {{ item.name }}</span>
      <div @click="removeFile(index)">
        <vs-icon
          class="ml-2 trash-icon"
          color="danger"
          icon-pack="feather"
          icon="icon-trash-2"
          size="small"
        ></vs-icon>
      </div>
    </div>

    <div class="mt-4 flex flex-row justify-end items-end">
      <vs-button
        :disabled="noDescription"
        style="height: min-content"
        color="success"
        @click="save"
        >Salvar</vs-button
      >
    </div>
  </div>
</template>
<script>
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.snow.css';

export default {
  name: 'FormOccurrence',
  props: ['entityId', 'saveOccurrenceApi'],
  components: { quillEditor },
  data() {
    return {
      occurrenceOptions: {
        placeholder: 'Descreva a ocorrência',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ align: [] }],
            ['link'],
          ],
        },
      },
      active: false,
      maxSize50Mb: 50 * 1024 * 1024,
      maxSizeMessage: 'Os arquivos selecionados devem ter no total 50MB.',
      form: {
        entityId: null,
        description: '',
        attachments: [],
      },
    };
  },
  computed: {
    noDescription() {
      return this.form.description.trim() === '';
    },
  },
  methods: {
    openModal() {
      this.active = true;
    },
    update() {
      this.form.description = '';
      this.form.attachments = [];
      this.$emit('update');
    },
    handleFiles(files) {
      const filesArray = Array.from(files);

      const currentTotalSize = this.form.attachments.reduce(
        (acc, file) => acc + file.size,
        0,
      );

      const newFilesTotalSize = filesArray.reduce(
        (acc, file) => acc + file.size,
        0,
      );

      if (currentTotalSize + newFilesTotalSize > this.maxSize50Mb) {
        notify.notifyFail(this.$vs, this.maxSizeMessage);
        return;
      }

      filesArray.forEach((file) => {
        const sanitizedFileName = functions.sanitizeString(file.name);
        const sanitizedFile = new File([file], sanitizedFileName, {
          type: file.type,
        });

        this.form.attachments.push(sanitizedFile);
      });
    },
    chooseFiles(inputId) {
      document.getElementById(inputId).click();
    },
    removeFile(index) {
      this.form.attachments.splice(index, 1);
    },
    async save() {
      try {
        const allFilesSize = this.form.attachments.reduce(
          (acc, file) => acc + file.size,
          0,
        );

        if (allFilesSize > this.maxSize50Mb) {
          notify.notifyFail(this.$vs, this.maxSizeMessage);
          return;
        }

        this.$vs.loading();
        this.form.entityId = this.entityId;
        await this.saveOccurrenceApi(this.form);
        notify.notifySuccess(this.$vs, 'Ocorrência cadastrada com sucesso.');
        this.$vs.loading.close();
        this.update();
      } catch (error) {
        notify.notifyFail(this.$vs, 'Erro ao cadastrar ocorrência.');
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.trash-icon {
  cursor: pointer;
  padding: 5px;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.trash-icon:hover {
  background-color: rgb(252, 230, 230);
}
</style>

<style lang="scss">
.occurrence-editor .ql-editor {
  // height: 12vh;
}
</style>
